import React from "react";
import styled from "styled-components";
import { useSearchParams, Link } from "react-router-dom";

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 25px;
  background: #2a2a2a;

  color: #000;

  li {
    margin: 0 0 15px 0;
  }
`;

const Inner = styled.div`
  border: solid 1px #989898;
  padding: 40px 80px;
  background: #eaeaea;
`;

const Langs = styled.div`
  margin: 0 0 55px 0;
`;

const Lang = styled(Link)`
  background: #000000;
  color: #fff;
  padding: 10px;
  margin: 0 10px 0 0;
`;

interface Props {}

const DeleteProfileInfoView = ({}: Props) => {
  const [searchParams] = useSearchParams();
  let app_name = searchParams.get("app_name");
  let lang = searchParams.get("lang");

  console.log("app_name", app_name);
  console.log("lang", lang);

  if (app_name === null) {
    app_name = "UA State";
  }

  return (
    <Wrapper>
      <Inner>
        <Langs>
          <Lang to={`/delete-profile-info/?app_name=${app_name}&lang=en`}>
            English
          </Lang>
          <Lang to={`/delete-profile-info/?app_name=${app_name}&lang=ua`}>
            Ukrainian
          </Lang>
        </Langs>
        {lang === "ua" ? (
          <>
            <h2>
              Запит на видалення облікового запису у застосунку {app_name}:
            </h2>
            <ul>
              <li>Перейдіть у застосунку на екран "Профіль"</li>
              <li>Натисніть іконку "Редагувати профіль"</li>
              <li>Натисніть іконку "Видалити"</li>
              <li>
                Введіть пароль від вашого облікового запису і натисніть кнопку
                "Видалити"
              </li>
            </ul>

            <h2>Типи даних, які будуть видалені:</h2>
            <ul>
              <li>Всі дані вашого облікового запису будуть видалені</li>
            </ul>
          </>
        ) : (
          <>
            <h2>Request to delete your account in the {app_name} app</h2>
            <ul>
              <li>Go to the "Profile" screen in the app</li>
              <li>Click the "Edit Profile" icon</li>
              <li>Click the "Delete" icon</li>
              <li>Enter your account password and click the "Delete" button</li>
            </ul>

            <h2>Types of data that will be deleted:</h2>
            <ul>
              <li>All of your account data will be deleted</li>
            </ul>
          </>
        )}
      </Inner>
    </Wrapper>
  );
};

export default DeleteProfileInfoView;
